import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  public collapsed = new BehaviorSubject<boolean>(false);
  constructor() {}

  public collapse() {
    this.collapsed.next(true);
  }
}
